import * as React from "react";
export const UsuarioBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
